export default __webpack_public_path__ + "locales/lv/Payments.json?hash=5f89af8aba55e7fb7d35a22e35ef82b4";